export default __webpack_public_path__ + "static/media/iconEarth.2d3d6893.svg";